import {ListGroup, ListGroupItem} from 'react-bootstrap';
import {formatAmount} from '../../../common/components/DisplayAmount';
import React from 'react';
import {flowRight as compose} from 'lodash';
import PropTypes from 'prop-types';
import {withTranslation} from 'react-i18next';
import {BILLING_SUBSCRIPTION_PLAN_BILLING_SCHEME} from '../../../common/constants';

const SubscriptionPlanInfo = ({t, subscriptionPlan, currentUsage}) => (
  <ListGroup variant={'flush'}>
    {subscriptionPlan.billingScheme === BILLING_SUBSCRIPTION_PLAN_BILLING_SCHEME.PER_UNIT && (
      <ListGroupItem className={'p-1'}>
        {t('subscriptionPlanInfo.price_excl_vat_per_' + subscriptionPlan.intervalCount + '_' + subscriptionPlan.interval, {
          price: formatAmount(subscriptionPlan.amount),
        })}
      </ListGroupItem>
    )}
    {subscriptionPlan.billingScheme === BILLING_SUBSCRIPTION_PLAN_BILLING_SCHEME.TIERED && subscriptionPlan.tiers.map((tier, index) => (
      <ListGroupItem key={index} className={'p-1'}>
        {tier.upTo !== null ? t('subscriptionPlanInfo.until_receipts', {upTo: tier.upTo}) : t('subscriptionPlanInfo.then')}
        {tier.flatAmount > 0 && t('subscriptionPlanInfo.price_excl_vat_per_' + subscriptionPlan.intervalCount + '_' + subscriptionPlan.interval, {
          price: formatAmount(tier.flatAmount),
        })}
        {tier.flatAmount > 0 && tier.unitAmount > 0 && ' + '}
        {tier.unitAmount > 0 && t('subscriptionPlanInfo.price_excl_vat_per_receipt_per_' + subscriptionPlan.intervalCount + '_' + subscriptionPlan.interval, {
          price: formatAmount(tier.unitAmount),
        })}
      </ListGroupItem>
    ))}
    {currentUsage !== null && (
      <ListGroupItem className={'p-1'}>
        {t('subscriptionPlanInfo.total_receipt', {totalReceipts: currentUsage})}
      </ListGroupItem>
    )}
  </ListGroup>
);

SubscriptionPlanInfo.defaultProps = {
  currentUsage: null,
};

SubscriptionPlanInfo.propTypes = {
  t: PropTypes.func.isRequired,
  subscriptionPlan: PropTypes.shape({
    amount: PropTypes.number,
    billingScheme: PropTypes.oneOf(Object.values(BILLING_SUBSCRIPTION_PLAN_BILLING_SCHEME)).isRequired,
    interval: PropTypes.string.isRequired,
    intervalCount: PropTypes.number.isRequired,
    tiers: PropTypes.arrayOf(
      PropTypes.shape({
        flatAmount: PropTypes.number,
        unitAmount: PropTypes.number,
        upTo: PropTypes.number,
      }),
    ),
  }).isRequired,
  currentUsage: PropTypes.number,
};

export default compose(
  withTranslation('stripe'),
)(SubscriptionPlanInfo);
